export const hasBranch = ["GH"];
export const isNonEu = ["NG", "GH", "ZA", "KE", "UG", "TZ", "CM"];
export const isKenyanBank = ["KE"];
